'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = gridReducer;

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _gridConstants = require('./gridConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = Immutable.Map({
    size: _gridConstants.GRID.MEDIUM.size,
    name: _gridConstants.GRID.MEDIUM.name
});

function gridReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _gridConstants.GRID_RESIZE:
            return Immutable.Map({
                size: action.gridSize,
                name: action.sizeName
            });
        default:
            return state;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/grid/gridReducer.js
// module id = 2125
// module chunks = 0